import useData from "./useData"
import useTemplatesList from "./useTemplatesList"

export default function useTypeData(type) {
  // more type mutable states
  return {
    ...useData(type),
    templates: useTemplatesList(type),
  }
}
